import { useEffect, useRef } from "react";

import { useAccountSelector } from "store";

import { useGlobalSocket } from "../../store/services";

const eventName = "extraction.result";

export function useExtractionResultSocketHook({
  fileId,
  onResult
}: {
  fileId: number | undefined;
  onResult: (success: boolean) => void;
}) {
  const socket = useGlobalSocket();
  const { show_recommendations } = useAccountSelector() || {};
  const onResultRef = useRef(onResult);

  useEffect(() => {
    onResultRef.current = onResult;
  });

  useEffect(() => {
    if (!fileId || !socket || !show_recommendations) return;
    const channelName = `private-extraction-result.${fileId}`;
    console.log(`[Subscribe to Extraction Result ${fileId}]`);
    const channel = socket.subscribe(channelName);

    channel.bind(eventName, ({ success }: { success: boolean }) => {
      return onResultRef.current(success);
    });

    return () => {
      console.log(`[Unsubscribe from Extraction Result ${fileId}]`);
      socket.unsubscribe(channelName);
    };
  }, [fileId, socket]);
}
